import React from 'react';
import { Save, Printer, PackageOpen, PackagePlus, Trash2, UserPlus, ArrowLeft } from 'lucide-react';

const BolToolbar = ({ 
    onSave,
    onPrint,
    onAddProducts,
    onEditQuantities,
    onNavigateToList,
    onNavigateToCompanies,
    bolID,
    onDelete 
}) => {
    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <div className="btn-group">
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onAddProducts}
                                title="Add Products"
                            >
                             Add <PackagePlus size={18} />
                            </button>
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onEditQuantities}
                                title="Edit Quantities"
                            >
                                Edit <PackageOpen size={18} />
                            </button>
                            <button
                                className="btn btn-outline-secondary"
                                onClick={onSave}
                                title="Save BOL"
                            >
                                <Save size={18} />
                            </button>
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onPrint}
                                title="Print BOL"
                            >
                                <Printer size={18} />
                            </button>
                        </div>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        {bolID && (
                            <div className="me-3">
                                <span className="badge bg-secondary">
                                    BOL ID: {new Date().getFullYear()}-{bolID}
                                </span>
                            </div>
                        )}
                        <div className="btn-group">
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onNavigateToList}
                                title="BOL List"
                            >
                                <ArrowLeft size={18} />
                            </button>
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onNavigateToCompanies}
                                title="Quick Add Company"
                            >
                                <UserPlus size={18} />
                            </button>
                            {bolID && (
                                <button 
                                    className="btn btn-outline-danger"
                                    onClick={onDelete}
                                    title="Delete BOL"
                                >
                                    <Trash2 size={18} />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
 
export default BolToolbar;